<template lang="pug">
    .image
        img(:src="this.image.src")
</template>
<script>
    export default {
        name: 'EvalImage',
        props: {
            image: {
                type: Object,
                required: true
            }
        }
    }
</script>
<style lang="sass">
    img
        max-width: 100%
</style>